<template>
    <hts-drawer
        v-model="visible"
        size="medium"
        :title="$t('labels.detailNodeConnection')"
        @close="close()">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                v-loading="!visible"
                class="grid gap-4 grid-cols-1">
                <hts-form-input
                    v-model="startNode.name"
                    :label="$t('labels.startNode')"
                    prop="startNode"
                    required
                    readonly />

                <span>
                    {{ $t('labels.businessConnection') }}
                    <span class="text-error-500 ml-1">
                        *
                    </span>
                </span>
                <div
                    v-for="(business, index) in businessData"
                    :key="index">
                    <hts-form-disclosure
                        v-if="Object.keys(startNode.businesses).includes(business._id)"
                        color="main"
                        size="large"
                        :is-have-children="true">
                        <template #reference>
                            <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white bg-main-500 hover:bg-main-600 w-full">
                                <input
                                    class="w-[17.5px] h-[17.5px]"
                                    disabled
                                    type="checkbox"
                                    :checked="Object.keys(dataAdd.businesses)?.includes(business._id)"
                                    :value="business._id" >
                                <span>
                                    {{ business.name }}
                                </span>
                            </div>
                        </template>
                        <template #children>
                            <div
                                v-for="(task, subIndex) in business.tasks"
                                :key="task">
                                <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white mt-3 ml-10 p-2 pl-3 bg-main-400">
                                    <input
                                        class="w-[17.5px] h-[17.5px]"
                                        type="checkbox"
                                        disabled
                                        :checked="Object.keys(startNode.businesses).includes(business._id) && startNode.businesses[business._id]?.includes(task._id)"
                                        :value="task._id" >
                                    <span>
                                        {{ task.name }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </hts-form-disclosure>
                </div>

                <hts-form-select
                    v-model="dataAdd.nodeConnection"
                    :text="nodeConnectionSelected"
                    :filterable="true"
                    :clearable="true"
                    :label="$t('labels.nodeConnection')"
                    required
                    prop="nodeConnection"
                    key-id="_id"
                    key-label="name"
                    readonly />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
const emits = defineEmits(['refreshTables'])
const { $disableReactive } = useNuxtApp()

const visible = ref(false)
const nodeId = ref('')
const connectionId = ref('')
const startNode = ref({
  name: '',
  nodeType: '',
  businesses: {} as { [key: string]: string[] }
})
const dataAdd = ref({
  startNode: '',
  businesses: {} as { [key: string]: string[] },
  nodeConnection: ''
})
const nodeConnectionSelected = ref('')
const businessData = ref<{ [key: string]: string }[]>([])

const open = async (id: string, idC: string) => {
  nodeId.value = id
  connectionId.value = idC
  dataAdd.value.startNode = id
  await getData()
  await getDataConnection()
  visible.value = true
}

const close = () => {
  visible.value = false
}

const resetField = () => {
  nodeId.value = ''
  dataAdd.value.startNode = ''
  startNode.value.name = ''
  startNode.value.nodeType = ''
  startNode.value.businesses = {}
  dataAdd.value.businesses = {}
  dataAdd.value.nodeConnection = ''
}

const getData = async () => {
  if (!nodeId.value) {
    return
  }
  const api = $urlAdmin.node.getById
  const data: any = await $api(api, { uriParams: { ID: nodeId.value } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    startNode.value.name = resData.data?.location?.locationName || ''
    startNode.value.nodeType = resData.data?.nodeType?._id || ''
    startNode.value.businesses = $disableReactive(resData.data?.businesses) || {}
    dataAdd.value.businesses = $disableReactive(resData.data?.businesses) || {}
  }
}

const getDataConnection = async () => {
  if (!connectionId.value) {
    return
  }
  const api = $urlAdmin.node.connection.getById
  const data: any = await $api(api, { uriParams: { ID: connectionId.value } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    dataAdd.value.businesses = resData.data.businesses
    if (resData.data?.nodeConnection) {
      const nodeConnection: any = resData.data?.nodeConnection
      nodeConnectionSelected.value = nodeConnection?.nodeType?.name + ' - ' + nodeConnection?.location?.locationName
    }
  }
}

watch(
  () => startNode.value.nodeType,
  async (val) => {
    // lấy thông tin nghiệp vụ
    const api = $urlAdmin.business.getByNodeType
    if (!val) {
      return
    }

    const data: any = await $api(api, { uriParams: { ID: val } })
    const resData = data?.data?.value
    if (resData?.success) {
      // data update UI
      businessData.value = resData.data
    }
  }
)

// watch(() => dataAdd.value.businesses, (val) => {
//   dataAdd.value.nodeConnection = []
// }, { deep: true })

defineExpose({
  open
})
</script>
